<template>
  <Checkout
    v-bind="$attrs"
    :action="route('checkout.contact', order)"
    :back="route('checkout.cart', order)"
    :order="order"
    :submit="submit"
    action-text="Weiter zum Versand"
    back-text="Zurück zum Warenkorb"
    step="contact"
  >
    <template #default>
      <h1 class="text-lg text-blue-500 mb-2">Kontaktinformationen</h1>
      <div class="grid xl:grid-cols-12 gap-4">
        <Fields
          v-model="form"
          :fields="only(fields, ['email'])"
          :errors="form.errors"
        />
      </div>

      <h2 class="text-md text-blue-500 mt-10 mb-2">Rechnungsadresse</h2>
      <div class="grid xl:grid-cols-12 gap-4">
        <Fields
          v-model="form"
          :fields="except(fields, ['email'])"
          :errors="form.errors"
        />
      </div>
    </template>
  </Checkout>
</template>

<script>
import Checkout from 'Web/Layouts/Checkout.vue';
import Fields from 'Web/Form/Fields.vue';
import { onMounted, reactive, toRefs } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';

export default {
  inheritAttrs: false,
  components: {
    Checkout,
    Fields,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      fields: null,
      form: null,
    });

    state.fields = {
      first_name: {
        width: '1/2',
        label: 'Vorname',
        type: 'text',
        autocomplete: 'given-name',
      },
      last_name: {
        width: '1/2',
        label: 'Nachname',
        type: 'text',
        autocomplete: 'family-name',
      },
      company: {
        label: 'Firma (optional)',
        type: 'text',
        autocomplete: 'organization',
      },
      street: {
        label: 'Straße und Hausnummer',
        type: 'text',
        autocomplete: 'street-address',
      },
      postal_code: {
        width: '1/3',
        label: 'Postleitzahl',
        type: 'text',
        autocomplete: 'postal-code',
      },
      city: {
        width: '2/3',
        label: 'Ort',
        type: 'text',
        autocomplete: 'address-level2',
      },
      country: {
        label: 'Land',
        type: 'select',
        autocomplete: 'country',
        options: {
          BE: 'Belgien',
          DE: 'Deutschland',
          NL: 'Niederlande',
        }
      },
      email: {
        label: 'E-Mail-Adresse',
        type: 'email',
        autocomplete: 'email',
      },
      phone: {
        label: 'Telefon (optional)',
        type: 'email',
        autocomplete: 'tel',
      },
    }

    const data = {
      ...mapValues(state.fields, (value, key) => null)
    }

    Object.assign(data, {
      ...props.order.billing_address
    });

    state.form = useForm('contact', data);

    onMounted(() => {
      state.form.clearErrors();
    });

    function submit(event) {
      state.form.post(event.target.action);
    }

    function only(array, only) {
      return pickBy(array, (value, key) => only.includes(key));
    }

    function except(array, except) {
      return pickBy(array, (value, key) => !except.includes(key));
    }

    return {
      ...toRefs(state),
      except,
      only,
      submit,
    }
  }
}
</script>
